<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" routerLink="{{routUrl}}">
        <span class="brand-logo">
          <!-- <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="230"/> -->
          MNRE R & D PORTAL
        </span>
        <span class="brand-logo">
        </span>
        <h2 class="brand-text mb-0"></h2>
        <!-- <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2> -->
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig?.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->
    <ul class="nav navbar-nav align-items-center">
      <!-- Language selection -->
      <li ngbDropdown class="nav-item dropdown dropdown-language">
        <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
          <span class="selected-language">
            <img src="assets/images/home-logo/Group 47.png" alt="" width="190px !important;">
          </span></a
      ></li>
      <!--/ Language selection -->
      </ul>
  </div>
 
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Toggle skin -->
    <!-- <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li> -->
    <!--/ Toggle skin -->

    <!-- Search -->
    <!-- <app-navbar-search></app-navbar-search> -->
    <!--/ Search -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <ng-container *ngIf="this.currentUser">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder"
              >{{ this.currentUser.name }}</span
            ><span class="user-status">{{ this.currentUser.role }}</span>
          </div>
          <span class="avatar"
            ><img
              class="round"
              src="assets/images/avatars/detaultProfile.jpg"
              alt="avatar"
              height="40"
              width="40" /><span class="avatar-status-online"></span
          ></span>
        </ng-container>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!-- <a ngbDropdownItem [routerLink]="['/pages/profile']"
          ><span [data-feather]="'user'" [class]="'mr-50'"></span> Profile</a
        >
        <div class="dropdown-divider"></div> -->
        <a ngbDropdownItem [routerLink]="['/pages/account-settings']"
          ><span [data-feather]="'settings'" [class]="'mr-50'"></span> Settings</a
        ><a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a>
      </div>
    </li>

    <li class="nav-item">
      <!-- <a
        class="nav-link dropdown-user-link"
        href="/login"
      > -->
      <ng-container *ngIf="this.currentUser == undefined">
        <div class="user-nav d-sm-flex d-none">
          <!-- <span class="user-name font-weight-bolder">Login</span> -->
          <img src="assets\images\home-logo\g20-logo.png" width="100PX" alt="logonew">
        </div>
        <!-- <span class="avatar"
          ><img
            class="round"
            src="assets/images/home-logo/logonew-removebg-preview 2.png"
            alt="avatar"
            height="40"
            width="40" /><span class="avatar-status"></span
        ></span> -->
      </ng-container>
      <!-- </a> -->
    </li>

    <li class="nav-item">
      <!-- <a
        class="nav-link dropdown-user-link"
        href="/login"
      > -->
      <ng-container *ngIf="this.currentUser == undefined">
        <div class="user-nav d-sm-flex d-none">
          <!-- <span class="user-name font-weight-bolder">Login</span> -->
          <img src="assets/images/home-logo/logonew-removebg-preview 2.png" alt="logonew">
        </div>
        <!-- <span class="avatar"
          ><img
            class="round"
            src="assets/images/home-logo/logonew-removebg-preview 2.png"
            alt="avatar"
            height="40"
            width="40" /><span class="avatar-status"></span
        ></span> -->
      </ng-container>
      <!-- </a> -->
    </li>

    <!--/ User Dropdown -->
  </ul>
</div>